// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navigationItem":"Navigation_navigationItem__WcOn0","selected":"Navigation_selected__2iEbc"};